import { StringUtil } from "./StringUtil";

class WhatsAppUtil {
    static buildUrl(phone: string, message: string): string {
        return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
    }

    static montarUrlProposta(tipoProposta: string, codigoVenda: string, telefone: string, message: string): string {
        if (!telefone) return '';
        if (!codigoVenda) return '';
        
        const telefoneSanitizado = telefone.replace(/\D/g, '')
        const url = `/propostas/${tipoProposta === "simplificada" ? "simplificada" : "detalhada"}/${StringUtil.encode64(codigoVenda, false, tipoProposta)}`
        const urlCompleta = `${window.location.origin}${url}`;
        return WhatsAppUtil.buildUrl(`55${telefoneSanitizado}`, message.replaceAll("{link_proposta}", urlCompleta))
    }
}

export { WhatsAppUtil }